module.exports = require('../dist/compat/function/throttle.js').throttle;
